import styled, { css } from 'styled-components';
import { Box } from '../Box/Box.js';

const TabsMenusWrapper = styled(Box)(({ theme: { olist: theme } }) => css `
    position: relative;

    :after {
      background-color: ${theme.color.neutral.soft};
      bottom: 0px;
      content: '';
      height: 1px;
      left: 0px;
      position: absolute;
      width: 100%;
    }
  `);
const styleActiveTab = css(({ theme: { olist: theme } }) => css `
    background: ${theme.color.primary.base};
    bottom: 0;
    content: '';
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    width: 100%;
  `);
const styleCommonTabButton = css(({ theme: { olist: theme } }) => css `
    padding: 13px ${theme.spacing.inset['1xsmall']};
    position: relative;
  `);
const styleActiveTabButton = ({ isActive }) => isActive &&
    css `
    & {
      color: ${({ theme }) => theme.olist.color.primary.base};
    }

    :after {
      ${styleActiveTab}
    }
  `;
const TabButton = styled.button(({ theme: { olist: theme } }) => css `
    ${styleCommonTabButton}
    ${styleActiveTabButton}

    display: inline-block;
    background-color: transparent;
    border: 1px solid transparent;
    font-size: ${theme.fontSize['1xsmall']};
    font-family: inherit;
    font-weight: ${theme.fontWeight.regular};
    color: ${theme.color.neutral.stronger};
    text-decoration: none;
    cursor: pointer;

    &:focus {
      color: ${theme.color.primary.base};
    }

    &:hover {
      color: ${theme.color.primary.base};
    }
  `);

export { TabButton, TabsMenusWrapper };
